import React from 'react';

export default function ProductBadges(props) {
  const badges = props.tags.filter(tag => tag.startsWith('badge:')).map(tag => tag.replace('badge:', ''));

  if (props.available && badges.length === 0) {
    return (null);
  }

  if (props.available) {
    return (
      <div className="badges-wrapper">
        {badges.map((badge, i) => <span className="badge badge-new" key={i}>{badge}</span>)}
      </div>
    )
  } else {
    let badge = <span className="badge badge-waitlist">Sold Out</span>
    if (!props.tags.includes('BIS-SoldOut') && props.tags.includes('BIS')) {
      badge = <span className="badge badge-waitlist">Join Waitlist</span>
    }
    return (
      <div className="badges-wrapper badge-waitlist-wrapper">
        {badge}
      </div>
    )
  }
}